import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class Rekening extends BaseModel {
  fields =  {
    'code': {
      label: 'Kode Rekening',
      type: 'text',
      rules: 'required'
    },
    'name': {
      label: 'Rincian Objek',
      type: 'text',
      rules: 'required'
    },
    // 'budget': {
    //   label: 'Budget',
    //   type: 'price',
    //   rules: 'required'
    // },
    // 'parent_id': {
    //   type: 'enum',
    //   label: 'parent_id',
    //   rules: 'required',
    //   options: []
    // },
  }

  endpoint = process.env.VUE_APP_API_URL + 'account-codes'
}